// constants.js
export const OTP_REGISTER_REQUEST = 'OTP_REGISTER_REQUEST';
export const OTP_REGISTER_SUCCESS = 'OTP_REGISTER_SUCCESS';
export const OTP_REGISTER_FAILURE = 'OTP_REGISTER_FAILURE';
